export const BulletList = ({ items }: { items: readonly string[] }) => {
    return (
        <ul>
            {items.map((item, index) => (
                <li key={index} className="flex gap-2">
                    <span className="shrink-0">•</span>
                    <span>{item}</span>
                </li>
            ))}
        </ul>
    );
};
